var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeviasIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 33,
    viewBox: "0 0 143 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.370117H5.56279V28.025H14.7165V32.6342H0V0.370117Z",
    fill: "#43ADA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7063 13.9652H30.343V18.5743H22.7063V28.025H32.3148V32.6342H17.1436V0.370117H32.3148V4.97927H22.7063V13.9652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1496 26.6866L48.395 0.370117H53.503L48.0422 32.6342H39.7469L34.2861 0.370117H39.8999L44.1496 26.6866Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.083 0.370117H61.6458V32.6342H56.083V0.370117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6922 32.6342H78.0784L77.118 26.7813H70.2931L69.3327 32.6342H64.2246L69.8851 0.370117H78.0275L83.6922 32.6342ZM70.9985 22.4002H76.3573L73.6758 6.0853L70.9943 22.4002H70.9985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5628 8.11228C85.5628 5.5 86.247 3.49452 87.6112 2.09585C88.9753 0.697183 91.0236 0 93.7562 0C96.4887 0 98.537 0.697183 99.9012 2.09585C101.265 3.49452 101.949 5.5 101.949 8.11228V9.12793H96.6884V7.78952C96.6884 6.62324 96.4419 5.80125 95.9532 5.32355C95.4645 4.84585 94.7803 4.60915 93.9049 4.60915C93.0295 4.60915 92.3453 4.84585 91.8566 5.32355C91.3679 5.80125 91.1214 6.62324 91.1214 7.78952C91.1214 8.89554 91.3891 9.87246 91.9288 10.716C92.4685 11.5595 93.1442 12.3599 93.9517 13.1131C94.7591 13.8662 95.6303 14.6193 96.5567 15.3725C97.4831 16.1256 98.35 16.9476 99.1617 17.8384C99.9691 18.7293 100.645 19.7449 101.185 20.8811C101.724 22.0172 101.992 23.3556 101.992 24.892C101.992 27.5043 101.291 29.5098 99.8927 30.9084C98.4945 32.3071 96.4292 33.0043 93.6967 33.0043C90.9641 33.0043 88.8988 32.3071 87.5007 30.9084C86.1026 29.5098 85.4014 27.5043 85.4014 24.892V22.9081H90.6624V25.2105C90.6624 26.3768 90.9217 27.1944 91.4444 27.6549C91.9671 28.1154 92.664 28.3478 93.5437 28.3478C94.4234 28.3478 95.1203 28.1154 95.643 27.6549C96.1657 27.1944 96.4249 26.3811 96.4249 25.2105C96.4249 24.1045 96.153 23.1275 95.6175 22.284C95.0778 21.4405 94.4021 20.6401 93.5947 19.8869C92.7873 19.1338 91.9161 18.3807 90.9896 17.6275C90.0632 16.8744 89.1963 16.0524 88.3846 15.1616C87.5772 14.2707 86.9015 13.2551 86.3618 12.1189C85.8221 10.9828 85.5544 9.64437 85.5544 8.10798L85.5628 8.11228Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 33H123.204V0H118V33Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.009 33H135.241C140.445 33 143 30.1243 143 24.8443V8.15571C143 2.87571 140.445 0 135.241 0H127.009V33ZM135.147 4.71429C136.802 4.71429 137.796 5.56286 137.796 7.92V25.08C137.796 27.4371 136.802 28.2857 135.147 28.2857H132.213V4.71429H135.147Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeviasIconLogo);
export default __webpack_public_path__ + "static/media/levias-icon-logo.ed41bacbe5dfec05d5bb50966e186d1b.svg";
export { ForwardRef as ReactComponent };